/** @format */
import striptags from 'striptags';

import { decimalToCent } from '@toucan/client/global/currency';

import {
    DeliveryOptionsResponse,
    ShippingOption,
    ShippingOptionType,
} from '@toucan/client/core/shipping';

export const transformShippingOptions = (
    shippingOptions: DeliveryOptionsResponse,
    type: ShippingOptionType
): ShippingOption[] => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const array: ShippingOption[] = shippingOptions.map((option: any) => ({
        ...option,
        type,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        hasDatePicker: option.allowDatepick,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        value: decimalToCent(option.value),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        price: option.value,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        title: option.displayName,
        description:
            type === ShippingOptionType.COLLECTION
                ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
                  striptags(option.instruction)
                : '',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        subtitle:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            type === ShippingOptionType.SHIPPING ? option.description : '',
    }));

    // Sorts the options by their priority
    // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
    return array.sort((a, b) => {
        if (!a.priority || !b.priority) {
            return 0;
        }

        return a.priority - b.priority;
    });
};
